module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_pawcom_m.6ff9f59a58983c1532fa2deffb1dd3c1.png";